import React, {Component} from "react";
import LeftSideOrderNumber from "./LeftSideOrderNumber";
import { isSimilarObject } from "../../helper";

export default class LeftSide extends Component {
    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    render() {
        const {
            orderId,
            status,
            is_failed,
            is_auction,
            fail_reason_str,
            paramId
        } = this.props.inputProps;

        let menu = [];

        // if(!is_failed) {
        //     if (params.id && data.id && params.id == data.id) {
        //         if(data.status > 0){
        //             status = data.status;
        //             // menu.push("Создание заказа");
        //             menu.push("Черновик");
        //         }
        //         else{
        //             menu.push("Черновик");
        //         }   
                
        //     } else {
        //         menu.push("Создание заказа");
        //     }
        
        //     // menu.push("Размещение");
        //     menu.push(""); // hack чтобы не ломать всю структуру статусов на фронте.

        //     if(data.is_auction) {
        //         menu.push("Торги");
        //     }
        //     else{
        //         menu.push("Поиск исполнителя");
        //     }

        //     if(data.status === 9) {
        //         menu.push("Исполнитель назначен");
        //     }
            
        //     menu.push("Выполнение работы");

        //     // При статусе 7 и 8 добавляется два пункта меню.
        //     if (status === 7 || status === 8) {
        //         menu.push("Арбитраж");
        //         menu.push("Претензия");
        //     }

        //     menu.push("Приемка и оплата");
        //     menu.push("Завершен");
            
        // } else {
        //     menu.push("Заказ отменен");
        // }


        if(!status && status !== 0) {
            menu.push({title: "Создание заказа", inactive: false, current: (!status)});
        }

        if(status || status === 0) {
            menu.push({title: "Черновики", inactive: (status > 0), current: (status === 0)});
        }
        
        if(is_auction) {
            menu.push({title: "Торги", inactive: (status > 2), current: (status === 1 || status === 2)});
        }
        else{
            menu.push({title: "Поиск исполнителя", inactive: (status > 2), current: (status === 1 || status === 2)});
        }

        if(status === 9) {
            menu.push({title: "Исполнитель назначен", inactive: (status < 3), current: (status === 9)});
        }

        menu.push({title: "Выполнение работы", inactive: (status > 3 && status !== 9), current: (status === 3)});
        
        if (status === 7 || status === 8) {
            menu.push({title: "Арбитраж", inactive: (status <= 3 || status === 8), current: (status === 7)});
            menu.push({title: "Претензия", inactive: (status <= 4), current: (status === 8)});
        }

        menu.push({title: "Приемка и оплата", inactive: (status === 5 || status === 6), current: (status === 4)});
        menu.push({title: "Завершен", inactive: (status === 5 || status === 6), current: (status === 5 || status === 6)});

        if(is_failed) {
            menu = [];
            menu.push("Заказ отменен");
        }

        return (
            <div className="left-content left-content-width" style={{ justifyContent: "start" }}>
                <div className="left-content__fixed">
                    {
                        <div>
                            {
                                orderId && orderId == paramId ? <LeftSideOrderNumber number={orderId} /> : null
                            }

                            <ul className="menu-content-nav make-order-nav">
                                {
                                    menu.map((item, index) => {
                                        if(item.inactive) {
                                            return  <li key={index} className='done'>
                                                        {item.title}
                                                    </li>
                                        }
                                        else if(item.current) {
                                            return  <li key={index} className='active'>
                                                        {item.title}
                                                    </li>
                                        }
                                        
                                        return  <li key={index} className=''>
                                                    {item.title}
                                                </li>
                                    })
                                }
                            </ul>

                            {
                                is_failed ?
                                <div style={{marginTop: '30px', background: 'rgb(231, 76, 60)', color: 'rgb(255, 255, 255)', padding: '10px'}}>
                                    {fail_reason_str}
                                </div>
                                : null
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/LeftSide.js